var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartbeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.072L12 21.5L9.10397 18.632M2.98697 10.528C2.97862 9.47335 3.30396 8.44308 3.91649 7.5845C4.52902 6.72593 5.39735 6.08303 6.39732 5.74775C7.39728 5.41247 8.47766 5.40198 9.48394 5.71777C10.4902 6.03357 11.3709 6.65948 12 7.506C12.4135 6.95602 12.9361 6.49732 13.5351 6.1586C14.134 5.81989 14.7965 5.60845 15.4809 5.53752C16.1653 5.46659 16.8571 5.53769 17.5127 5.74639C18.1684 5.95508 18.774 6.29687 19.2915 6.75036C19.8091 7.20385 20.2274 7.75928 20.5204 8.38189C20.8134 9.0045 20.9747 9.68088 20.9943 10.3687C21.0138 11.0565 20.8912 11.741 20.6341 12.3792C20.377 13.0175 19.9909 13.5958 19.5 14.078M3 13.5H5L7 16.5L9 10.5L10 13.5H13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartbeat);
export default __webpack_public_path__ + "static/media/heartbeat.af0db836726afd0b736ea1fc7eed057d.svg";
export { ForwardRef as ReactComponent };